import type { ReactNode } from 'react';
import { Button } from './Button';
import { InlineAlert } from './InlineAlert';
import { Modal } from './Modal';
import styles from '@/styles/components/ConfirmModal/style.scss';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel: string;
  /** Label while the action runs, e.g. "Deleting…". */
  busyLabel?: string;
  busy?: boolean;
  /** Error from the last attempt, shown inside the dialog. */
  error?: string | null;
  tone?: 'danger' | 'primary';
  onConfirm: () => void;
  onCancel: () => void;
}

/** "Are you sure?" dialog for destructive actions. */
export function ConfirmModal({
  open,
  title,
  message,
  confirmLabel,
  busyLabel,
  busy,
  error,
  tone = 'danger',
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      width={440}
      footer={
        <>
          <Button variant="secondary" size="lg" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant={tone} size="lg" onClick={onConfirm} disabled={busy} data-autofocus>
            {busy && busyLabel ? busyLabel : confirmLabel}
          </Button>
        </>
      }
    >
      {error && <InlineAlert message={error} />}
      <p className={styles.message}>{message}</p>
    </Modal>
  );
}
